import React, { Component } from "react";
import { Link } from "react-router-dom";

import data from "../../../data/news.json";

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: data.news
        .sort((a, b) => {
          const aDate = new Date(a.releaseDate);
          const bDate = new Date(b.releaseDate);
          return bDate.getTime() - aDate.getTime();
        })
        .map((x) => {
          const date = new Date(x.releaseDate);
          return {
            ...x,
            id: x.ID,
            image: x.headerImage,
            text: x.shortContent,
            date: date.toLocaleDateString("hr-HR"),
            day: date.getDate(),
            month: date.getMonth() + 1,
          };
        })
        .slice(0, 3),
    };
  }

  render() {
    return (
      <div className="col-md-6">
        <div
          className="themesflat-content-box clearfix"
          data-margin="0 18px 0 0"
          data-mobilemargin="0 0 0 0"
        >
          <div className="themesflat-headings style-1 clearfix">
            <h2 className="heading">NOVOSTI</h2>
            <div className="sep has-width w80 accent-bg margin-top-11 clearfix" />
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={38}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="style-1 clearfix ">
            <div className="tab-content-wrap clearfix widget widget_lastest">
              <ul className="lastest-posts data-effect clearfix">
                {this.state.tab.map((data) => (
                  <li className="clearfix">
                    <div
                      className="thumb data-effect-item has-effect-icon"
                      style={{
                        width: "30%",
                        height: "180px",
                        backgroundImage: `url(${data.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        marginTop: "30px",
                      }}
                    >
                      <div className="overlay-effect bg-color-2" />
                      <div className="elm-link">
                        <Link
                          to={`/news?ID=${data.ID}&name=${data.title.replaceAll(
                            " ",
                            "-"
                          )}`}
                          className="icon-2"
                        />
                      </div>
                    </div>
                    <div className="text">
                      <span className="post-date">
                        <span className="entry-date">{data.date}</span>
                      </span>
                      <h3
                        style={{
                          fontSize: 16,
                          fontWeight: "600",
                          marginBottom: "15px",
                        }}
                      >
                        <Link
                          to={`/news?ID=${data.ID}&name=${data.title.replaceAll(
                            " ",
                            "-"
                          )}`}
                        >
                          {data.title}
                        </Link>
                      </h3>
                      <p>{data.text}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            {/* /.tab-content-wrap */}
          </div>
          {/* /.themesflat-tabs */}
        </div>
        {/* /.themesflat-content-box */}
      </div>
    );
  }
}

export default Overview;
